import React from "react";
import PropTypes from "prop-types";
import Message from "shared/components/oknf/_Message";
import classnames from "classnames";

const Typable = React.forwardRef((props, ref) => {
	const {
		success,
		error,
		isSearching,
		className,
		children,

		...inputProps
	} = props;

	const isInputType = !!Typable._inputTypes[props.type];
	const isTextarea = props.type === "textarea";

	const typeableWrapperClasses = classnames(
		"oknf-typable-wrapper",
		`oknf-typable-wrapper--${props.type}`,
	);

	const typableClasses = classnames(
		className, {
			"oknf-input": isInputType,
			"oknf-textarea": isTextarea,
			"oknf-input--success": success,
			"oknf-input--error": error,
			"oknf-input--is-searching": isSearching,
			"oknf-input--is-readonly": props.readOnly,
		});

	const typableProps = {
		...inputProps,

		ref,
		className: typableClasses,
		disabled: props.disabled || props.readOnly,
	};

	return (
		<span className={typeableWrapperClasses}>
			{isInputType && (
				<input {...typableProps} />
			)}
			{isTextarea && (
				<textarea {...typableProps} />
			)}
			{error && typeof error === "string" && (
				<Message type="error" message={error} />
			)}
			{success && typeof success === "string" && (
				<Message type="success" message={success} />
			)}
			{children}
		</span>
	);
});

Typable.displayName = "Typable";

Typable.propTypes = {
	type: PropTypes.string.isRequired,
	className: PropTypes.string,
	value: PropTypes.any,
	children: PropTypes.node,
	readOnly: PropTypes.bool,
	disabled: PropTypes.any,

	// messages / statuses
	success: PropTypes.oneOfType([
		PropTypes.bool,
		PropTypes.string,
	]),
	error: PropTypes.oneOfType([
		PropTypes.bool,
		PropTypes.string,
	]),
	isSearching: PropTypes.bool,
};

Typable.defaultProps = {
	className: "",
	value: "",
	children: null,
	readOnly: false,
	disabled: false,
	success: null,
	error: null,
	isSearching: null,
};

Typable._inputTypes = {
	text: 1,
	password: 1,
	email: 1,
	search: 1,
	number: 1,
	tel: 1,
};

export default Typable;



// WEBPACK FOOTER //
// ./src/shared/components/oknf/_Typable.jsx